import * as types from '../types';
import Song from '../../models/Song';
import sha256 from 'crypto-js/sha256';

// Initial state
// -------------
const state = {
    songs: Song.getSongsList(),
};

// Getters
// -------
const getters = {
    songs: state => state.songs,
};

// Mutations
// ---------
const mutations = {
    /**
     * Enregistrement d'une chanson
     *
     * @author Fabien Bellanger
     * @param {Object}  state
     * @param {Object}  payload
     */
    [types.M_SONGSLIST_ADD_SONG](state, payload)
    {
        if (payload.id === undefined || payload.id === 0)
        {
            // Enregistrement pour la première fois le chanson, on lui attribut un ID
            // ----------------------------------------------------------------------
            const date = new Date();

            payload.id = sha256(payload.title + payload.author + date.getTime()).toString();

            state.songs.push(payload);
        }
        else
        {
            // Modification
            // ------------
            const songIndex = state.songs.findIndex((element) =>
            {
                return element.id === payload.id;
            });

            if (songIndex === -1)
            {
                // L'ID n'a pas été trouvé, on ajoute la chanson
                // ---------------------------------------------
                state.songs.push(payload);
            }
            else
            {
                // On modifie la chanson
                // ---------------------
                state.songs.splice(songIndex, 1, payload);
            }
        }

        localStorage.setItem('songsList', JSON.stringify(state.songs));
    },
    /**
     * Enregistrement d'une chanson
     *
     * @author Fabien Bellanger
     * @param {Object}  state
     * @param {Object}  songId ID de la chanson
     */
    [types.M_SONGSLIST_DELETE_SONG](state, songId)
    {
        console.log(songId);

        const songIndex = state.songs.findIndex((element) =>
        {
            return element.id === songId;
        });

        if (songIndex !== -1)
        {
            state.songs.splice(songIndex, 1);
        }

        localStorage.setItem('songsList', JSON.stringify(state.songs));
    },
};

// Actions
// -------
const actions = {
    /**
     * Enregistrement d'une chanson
     *
     * @author Fabien Bellanger
     * @param {Object}  store
     * @param {Object}  payload
     */
    [types.A_SONGSLIST_ADD_SONG](store, payload)
    {
        store.commit(types.M_SONGSLIST_ADD_SONG, payload);

        // On indique que la chanson n'est plus "modifiée"
        // -----------------------------------------------
        store.commit(types.M_SONG_TOGGLE_IS_MODIFIED, false);
    },
    /**
     * Suppressopn d'une chanson
     *
     * @author Fabien Bellanger
     * @param {Object}  store
     * @param {Object}  songId ID de la chanson
     */
    [types.A_SONGSLIST_DELETE_SONG](store, songId)
    {
        store.commit(types.M_SONGSLIST_DELETE_SONG, songId);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
